define([
    'edge/platform/l10n/directives/LanguageSelectDirective',
    'edge/platform/l10n/directives/LanguageExpandosDirective',
    'edge/platform/l10n/directives/DisplaykeyFormatterDirective',
    'edge/platform/l10n/CurrencyFilter',
    'edge/platform/l10n/LocaleService',
    'edge/platform/featuredetection/ApplicationFeatures',
    'edge/platform/l10n/TranslateService',
    'edge/platform/l10n/DateFormatter',
    'text!app-locale',
    'portalConfig',
    'angular-cookies',
    'angular-translate',
    'angular-translate-storage-cookie',
    'angular-translate-storage-local',
    'angular-translate-loader-static-files',
    'angular-translate-handler-log',
    'angular-dynamic-locale',
    'bower_components/angular-sanitize/angular-sanitize'
], (LanguageSelectDirective, LanguageExpandosDirective, DisplaykeyFormatterDirective, CurrencyFilter, LocaleService, ApplicationFeatures, TranslateService, DateFormatter, localeJSON)=> {
    return angular.module('edge.platform.l10n', [
            // start l10n
            'ngCookies',
            'pascalprecht.translate',
            'portal.config',
            'tmh.dynamicLocale',
            'ngSanitize'
        ])
        .directive('gwPlLanguageSelect', LanguageSelectDirective)
        .directive('gwPlLanguageExpandos', LanguageExpandosDirective)
        .directive('gwDisplaykeyFormat', DisplaykeyFormatterDirective)
        .service('LocaleService', LocaleService)
        .service('DateFormatter', DateFormatter)
        .filter('gwCurrency', CurrencyFilter)
        .constant('DEBUG_MODE', /*DEBUG_MODE_START*/true/*DEBUG_MODE_END*/)
        .constant('ANGULAR-I18N', /*ANGULAR-I18N_START*/'../../common/js/bower_components/angular-i18n'/*ANGULAR-I18N_END*/)
        .constant('LOCALE_INFO', JSON.parse(localeJSON))
        // Angular debug info
        .config(['$compileProvider', 'DEBUG_MODE', ($compileProvider, DEBUG_MODE)=> {
            if (!DEBUG_MODE) {
                $compileProvider.debugInfoEnabled(false);// disables AngularJS debug info
            }
        }])
        .config([
            '$translateProvider', 'DEBUG_MODE', 'ASYNC_TRANSLATIONS', 'LOCALE_INFO', 'TRANSLATE_PROVIDER_PREFIX',
            ($translateProvider, DEBUG_MODE, ASYNC_TRANSLATIONS, LOCALE_INFO, TRANSLATE_PROVIDER_PREFIX)=> {
                if (DEBUG_MODE) {
                    $translateProvider.useMissingTranslationHandlerLog();// warns about missing translates
                }

                if (ASYNC_TRANSLATIONS) {
                    $translateProvider.useStaticFilesLoader({
                        prefix: TRANSLATE_PROVIDER_PREFIX || '../js/i18n/translations/',
                        suffix: '.json'
                    });
                }

                $translateProvider.useSanitizeValueStrategy(null);// http://angular-translate.github.io/docs/#/guide/19_security
                $translateProvider.preferredLanguage(LOCALE_INFO.preferredLocale);
                $translateProvider.useLocalStorage();
            }])
        // Angular Dynamic Locale
        .config(['tmhDynamicLocaleProvider', 'ANGULARI18N_PRESET', 'ANGULAR-I18N', (tmhDynamicLocaleProvider, ANGULARI18N_PRESET, ANGULARI18N)=> {
            // ANGULARI18N_PRESET is added to reset angular locales path from 3rd party "Portals" (e.g. Components Examples)
            tmhDynamicLocaleProvider.localeLocationPattern(`${ANGULARI18N_PRESET || ANGULARI18N}/angular-locale_{{locale}}.js`);
        }])
        .service('TranslateService', TranslateService);
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/l10n/module.js
 **/